import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils.ts';

export function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return <LabelPrimitive.Root className={cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)} {...props} />;
}

/**
 * Filtro de una lista con su rótulo pequeño arriba (auditoría de frontend FE-15): el desplegable se entiende sin abrirlo
 * y el lector de pantalla lo nombra. La barra de filtros que lo usa alinea por abajo (`items-end`).
 */
export function Filtro({ etiqueta, children, className }: { etiqueta: string; children: React.ReactNode; className?: string }) {
  return (
    <label className={cn('grid gap-0.5 text-[11px] font-medium text-muted-foreground', className)}>
      {etiqueta}
      {children}
    </label>
  );
}

/** Campo de formulario: label + control + error en español debajo (skill diseno-visual-mg). */
export function Campo({ etiqueta, error, htmlFor, children, className, ayuda }: { etiqueta: string; error?: string | undefined; htmlFor?: string; children: React.ReactNode; className?: string; ayuda?: string }) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={htmlFor}>{etiqueta}</Label>
      {children}
      {error ? (
        <p className="text-xs text-destructive" role="alert">
          {error}
        </p>
      ) : ayuda ? (
        <p className="text-xs text-muted-foreground">{ayuda}</p>
      ) : null}
    </div>
  );
}
